import { createContext } from "react";

import { Pharmacy } from "@meditect/medibase-api-client";

export interface PharmacyContextValue {
  pharmacy: Pharmacy;
}

export const PharmacyContext = createContext<PharmacyContextValue | null>(null);
